import { IConfig } from '../../repository/config';
import { EnableEnum } from '../../repository/vendor';

export const checkBrandCondition = (options?: string[], brand?: string) => {
    if (!options || !brand) {
        return false;
    }
    return options?.includes(brand);
};

export const checkActiveCampaign = (
    countryConfig: IConfig | undefined | null,
    voucherHasActiveCampaign: EnableEnum | undefined,
    brandId?: string,
): boolean => {
    if (!countryConfig) {
        return false;
    }
    if (voucherHasActiveCampaign === EnableEnum.Enable) {
        return true;
    }
    if (voucherHasActiveCampaign && voucherHasActiveCampaign === EnableEnum.Disable) {
        return false;
    }
    if (countryConfig.displayCodeBoxCondition === 'all') {
        return true;
    }
    if (countryConfig.displayCodeBoxCondition === 'byBrand') {
        if (!brandId) {
            return false;
        }
        return checkBrandCondition(countryConfig.displayCodeBoxBrands, brandId);
    }

    return false;
};
